var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 71,
    viewBox: "0 0 58 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.2145 31.2354L39.2147 31.2378C39.2165 31.2574 39.2142 31.2773 39.208 31.296C39.2017 31.3147 39.1916 31.332 39.1784 31.3466C39.1651 31.3612 39.1489 31.3729 39.1309 31.3809C39.1132 31.3888 39.0941 31.393 39.0747 31.3933H18.8908C18.8714 31.393 18.8523 31.3888 18.8346 31.3809C18.8165 31.3729 18.8004 31.3612 18.7871 31.3466C18.7738 31.332 18.7638 31.3147 18.7575 31.296C18.7512 31.2773 18.7489 31.2574 18.7507 31.2378L18.751 31.2354C18.9781 28.6784 20.1544 26.2992 22.0481 24.5662C23.9418 22.8332 26.4158 21.872 28.9827 21.8719L39.2145 31.2354ZM39.2145 31.2354C38.9874 28.6784 37.8111 26.2992 35.9174 24.5662C34.0237 22.8332 31.5498 21.872 28.9828 21.8719L39.2145 31.2354Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 20980_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.4003 28.8438C23.9628 28.8438 19.9691 31.5063 18.1941 35.5H38.6066C36.8316 31.5063 33.0597 28.8438 28.4003 28.8438Z",
    fill: "#01684A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.3997 24.4062C30.8504 24.4062 32.8372 22.4195 32.8372 19.9688C32.8372 17.518 30.8504 15.5312 28.3997 15.5312C25.9489 15.5312 23.9622 17.518 23.9622 19.9688C23.9622 22.4195 25.9489 24.4062 28.3997 24.4062Z",
    fill: "#01684A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M49.2563 0H8.43125C3.77188 0 0 3.77188 0 8.43125V62.5688C0 67.2281 3.77188 71 8.43125 71H49.2563C53.9156 71 57.6875 67.2281 57.6875 62.5688V8.43125C57.6875 3.77188 53.9156 0 49.2563 0ZM21.9656 25.9594C20.6344 24.4062 19.7469 22.4094 19.7469 19.9688C19.7469 15.0875 23.7406 11.0938 28.6219 11.0938C33.5031 11.0938 37.4969 15.0875 37.4969 19.9688C37.4969 22.1875 36.6094 24.1844 35.2781 25.9594C39.7156 28.1781 43.0437 32.3937 43.9312 37.4969C43.9312 38.1625 43.9313 38.8281 43.4875 39.2719C42.8219 39.7156 42.1562 39.9375 41.4906 39.9375H15.3094C14.6437 39.9375 13.9781 39.7156 13.5344 39.05C13.0906 38.6063 12.8687 37.9406 13.0906 37.275C13.9781 32.1719 17.3062 27.9562 21.9656 25.9594ZM46.5938 59.9062H11.0938C9.7625 59.9062 8.875 59.0187 8.875 57.6875C8.875 56.3563 9.7625 55.4688 11.0938 55.4688H46.5938C47.925 55.4688 48.8125 56.3563 48.8125 57.6875C48.8125 59.0187 47.925 59.9062 46.5938 59.9062ZM46.5938 51.0312H11.0938C9.7625 51.0312 8.875 50.1437 8.875 48.8125C8.875 47.4813 9.7625 46.5938 11.0938 46.5938H46.5938C47.925 46.5938 48.8125 47.4813 48.8125 48.8125C48.8125 50.1437 47.925 51.0312 46.5938 51.0312Z",
    fill: "#01684A"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvImage);
export default __webpack_public_path__ + "static/media/CVImage.7c3a7da2516e7c70a7c2cce7dae5118d.svg";
export { ForwardRef as ReactComponent };